import { offlineDb } from './db'

let nextId: number | null = null

const SAFE_FLOOR = -2_000_000_000

export async function nextTempId(): Promise<number> {
  if (nextId === null) {
    const items = await offlineDb.mutationQueue.toArray()
    let min = 0
    for (const item of items) {
      if (typeof item.entityId === 'number' && item.entityId < min && item.entityId > SAFE_FLOOR) {
        min = item.entityId
      }
    }
    nextId = min
  }
  nextId -= 1
  return nextId
}
